import { Aufnahmebogen } from './Aufnahmebogen';
import { IDs } from '../../../helpers/IDs';

export class AufnahmebogenBwl extends Aufnahmebogen {

    protected dataIgnored: any = {};

    constructor(dataSheet: Array<any>, dataDb: any) {
        super(dataSheet, dataDb);

        if (dataSheet.length) {
            this.initData(IDs.ENT_BETRIEBSDATEN);
            this.setJahre();
            this.setData();
        }
    }

    public getData(): Array<any> {
        const data: any = this.data;

        Object.keys(data).forEach((entity: any) => {
            data[entity] = this.getDataValided(data[entity]);
            const compare: Array<any> = this.dataIgnored[entity].map((item: any) => item.jahr);
            data[entity] = data[entity].filter((row: any) => compare.indexOf(row.jahr) === -1);
        });

        return data;
    }

    protected getDataValided(data: Array<any>): Array<any> {
        return data.filter((row: any) =>
            row.anz_mitarbeiter
            || row.auslastung
            || row.beheizte_flaeche
            || row.umsatz
        );
    }

    private setData(): void {
        this.dataSheet.forEach((row: Array<string>, index: number) => {
            this.curRowIndex = index;
            const titel: string = this.getTitel() || null;

            if (index > 0) {
                this.setBemerkung();
            }

            switch (titel) {
                case 'Anzahl Mitarbeiter':
                    this.setValue('anz_mitarbeiter', (value: any, index: number) => {
                        if (typeof value === 'number') {
                            this.data[this.curEntity][index].anz_mitarbeiter = +value.toFixed(2);
                        }
                    });
                    break;
                case 'bebaute/beheizte Fläche':
                    // no break
                case 'Beheizte Fläche':
                    this.setValue('beheizte_flaeche', (value: any, index: number) => {
                        if (typeof value === 'number') {
                            this.data[this.curEntity][index].beheizte_flaeche = +value.toFixed(2);
                        }
                    });
                    break;
                case 'Jahresumsatz':
                    this.setValue('umsatz', (value: any, index: number) => {
                        if (typeof value === 'number') {
                            this.data[this.curEntity][index].umsatz = +value.toFixed(2);
                        }
                    });
                    break;
                case 'Betriebsauslastung':
                    this.setValue('auslastung', (value: any, index: number) => {
                        if (typeof value === 'number') {
                            this.data[this.curEntity][index].auslastung = +value.toFixed(2);
                        }
                    });
                    break;
            }
        });
        this.setDataIgnored();
    }

    private setDataIgnored(): void {
        const entity: string = IDs.ENT_BETRIEBSDATEN;
        const data: any = this.getDataValided(this.data[entity] || []);
        this.dataIgnored[entity] = [];

        data.forEach((row: any, index: number) => {
            const jahr: number = row.jahr || null;

            if (this.dataDb[entity].some((row: any) => row.jahr === jahr)) {
                this.dataIgnored[entity].push(data[index]);
            }
        });
    }
}
